import { defineSlotRecipe } from '@chakra-ui/react';
import { tableAnatomy } from '@chakra-ui/react/anatomy';

export type ThemeGenTableConfig = {
  stripedColor?: string;
};

//row colouring is now handled in chakraThemeBuilder.ts
export function generateTableRecipe(_?: ThemeGenTableConfig) {
  return defineSlotRecipe({
    slots: tableAnatomy.keys(),
    base: {
      columnHeader: {
        fontWeight: 'bold'
      }
    },
    variants: {
      striped: {
        true: {
          row: {
            '&:nth-of-type(odd) td': {
              bg: 'none'
            }
          }
        }
      },
      size: {
        sm: {
          root: {
            textStyle: 'sm'
          },
          columnHeader: {
            px: '4px',
            py: '4px'
          },
          cell: {
            px: '4px',
            py: '4px'
          }
        },

        md: {
          root: {
            textStyle: 'sm'
          },
          columnHeader: {
            px: '3',
            py: '3'
          },
          cell: {
            px: '3',
            py: '3'
          }
        },

        lg: {
          root: {
            textStyle: 'md'
          },
          columnHeader: {
            px: '4',
            py: '3'
          },
          cell: {
            px: '4',
            py: '3'
          }
        }
      }
    },
    defaultVariants: {
      size: 'sm',
      striped: true
    }
  });
}
